var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperPlane = function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.223 5.048C.221 4.157.851 2.5 2.192 2.5h15.54A1.46 1.46 0 0 1 19 4.681l-7.623 13.365c-.657 1.152-2.386.9-2.687-.391l-1.719-7.379 5.508-3.063a.625.625 0 0 0-.608-1.093L6.064 9.351z"
  })));
};
export default SvgPaperPlane;